import { computed } from 'mobx'
import memoize from 'moize'

import { createPatternMatcher } from './patternUtils'
import { parseQueryString } from './queryString'
import { getRoutingStore } from './routingStore'

const _emptyObject = {}

export const getComputedRouteParams = memoize((routePatterns: string[]) => {
  const matchers = routePatterns.map(createPatternMatcher)

  return computed(() => {
    let pathParams = {}
    let queryParams = {}

    for (const matcher of matchers) {
      const matchResult = matcher(getRoutingStore().location.pathname)

      if (matchResult === false) continue

      pathParams = matchResult.params
      queryParams = parseQueryString(getRoutingStore().location.search)
    }

    const pathParamsIsEmpty = Object.keys(pathParams).length === 0
    const queryParamsIsEmpty = Object.keys(queryParams).length === 0

    return pathParamsIsEmpty && queryParamsIsEmpty
      ? _emptyObject
      : {
          ...pathParams,
          ...queryParams,
        }
  })
})
